import { render, staticRenderFns } from "./InvestorBankAccounts.vue?vue&type=template&id=636c884a&scoped=true&"
import script from "./InvestorBankAccounts.vue?vue&type=script&lang=js&"
export * from "./InvestorBankAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636c884a",
  null
  
)

export default component.exports